import React, { useState } from "react";
import { Container, Row, Col, Form } from "react-bootstrap";
import HeaderNavbar from "./Navbar";
import Footer from "./Footer";

export default function Contact() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });


  const [errors, setErrors] = useState({});

  const inputStyle = {
    padding: "10px 12px",
    fontSize: "14px",
    background: "#fff",
    border: "1.5px solid #e5d8cf",
    borderRadius: "8px",
  };

  const labelStyle = {
    fontSize: "13px",
    fontWeight: "600",
    color: "#5a1424",
  };


  const validate = (name, value) => {
    let error = "";

    if (name === "name") {
      if (!value.trim()) error = "Please enter name ";
    }

    if (name === "email") {
      if (!value.trim()) error = "Please enter email";
      else if (!/\S+@\S+\.\S+/.test(value))
        error = "Enter valid email";
    }

    if (name === "phone") {
      if (!value.trim() && !/^[0-9]{10}$/.test(value))
        error = "Enter valid 10-digit phone";
    }

    if (name === "message") {
      if (!value.trim()) error = "Please enter message";
    }

    return error;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm({ ...form, [name]: value });


    const error = validate(name, value);
    setErrors({ ...errors, [name]: error });
  };

  const handleSubmit = (e) => {
    e.preventDefault();


    let newErrors = {};
    Object.keys(form).forEach((key) => {
      const error = validate(key, form[key]);
      if (error) newErrors[key] = error;
    });

    setErrors(newErrors);

    // ❌ STOP IF ERRORS
    if (Object.keys(newErrors).length > 0) return;

    alert("Message submitted successfully!");

    setForm({
      name: "",
      email: "",
      phone: "",
      message: "",
    });

    setErrors({});
  };

  return (
    <>
      <HeaderNavbar />

      <div style={{
        background: "#f8f5f2",
        padding: "60px 0",
        textAlign: "center",
      }}>
        <Container>
          <Row className="mb-5 text-center">
            <Col>
              <h1 style={{ color: "#7b1e3b", fontWeight: "600" }}>
                Contact Us
              </h1>
              <p style={{ color: "#777" }}>
                Have questions? We'd love to hear from you.
              </p>
            </Col>
          </Row>

          <Row>
            <Col lg={7}>
              <div
                style={{
                  background: "#fff",
                  padding: "35px",
                  borderRadius: "10px",
                  boxShadow: "0 5px 20px rgba(0,0,0,0.06)",
                }}
              >
                <h4 style={{ marginBottom: "25px", color: "#5a1424" }}>
                  Send us a message
                </h4>

                <Form onSubmit={handleSubmit}>
                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label style={labelStyle}>Name</Form.Label>
                        <Form.Control
                          name="name"
                          value={form.name}
                          onChange={handleChange}
                          placeholder="Enter name"
                          style={inputStyle}
                        />
                        {errors.name && (
                          <small style={{ color: "red" }}>
                            {errors.name}
                          </small>
                        )}
                      </Form.Group>
                    </Col>

                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label style={labelStyle}>Email</Form.Label>
                        <Form.Control
                          name="email"
                          value={form.email}
                          onChange={handleChange}
                          placeholder="Enter email"
                          style={inputStyle}
                        />
                        {errors.email && (
                          <small style={{ color: "red" }}>
                            {errors.email}
                          </small>
                        )}
                      </Form.Group>
                    </Col>
                  </Row>

                  <Form.Group className="mb-3">
                    <Form.Label style={labelStyle}>Phone</Form.Label>
                    <Form.Control
                      name="phone"
                      value={form.phone}
                      onChange={handleChange}
                      placeholder="Enter phone number"
                      style={inputStyle}
                    />
                    {errors.phone && (
                      <small style={{ color: "red" }}>
                        {errors.phone}
                      </small>
                    )}
                  </Form.Group>

                  <Form.Group className="mb-4">
                    <Form.Label style={labelStyle}>Message</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={4}
                      name="message"
                      value={form.message}
                      onChange={handleChange}
                      placeholder="Write your message"
                      style={inputStyle}
                    />
                    {errors.message && (
                      <small style={{ color: "red" }}>
                        {errors.message}
                      </small>
                    )}
                  </Form.Group>

                  <button
                    type="submit"
                    style={{
                      background: "#7b1e3b",
                      color: "#fff",
                      border: "none",
                      padding: "12px 25px",
                      borderRadius: "6px",
                      fontWeight: "600",
                    }}
                  >
                    Send Message
                  </button>
                </Form>
              </div>
            </Col>

            <Col lg={5}>
              <div
                style={{
                  background: "#fff",
                  padding: "35px",
                  borderRadius: "10px",
                  boxShadow: "0 5px 20px rgba(0,0,0,0.06)",
                }}
              >
                <h4 style={{ marginBottom: "20px", color: "#5a1424" }}>
                  Contact Information
                </h4>

                <p>
                  <strong>Office Address</strong>
                  <br />
                  KVL Matrimony Services
                  <br />
                  No.88, R.B.D.G.T.C Building, Near City Railway Station, Gubbi Thodappa Road, Bangalore - 560023
                </p>

                <p>
                  <strong>Phone</strong>
                  <br />
                  <a
                    href="tel:+919606010981"
                    className="text-decoration-none text-dark footer-contact-link"
                  >
                    +91 9606010981
                  </a>
                </p>

                <p>
                  <strong>Email</strong>
                  <br />
                  <a
                    href="mailto:support@kvlmatrimony.com"
                    className="text-decoration-none text-dark footer-contact-link"
                  >
                    support@kvlmatrimony.com
                  </a>
                </p>


              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <Footer />
    </>
  );
}